import {Component, inject, OnInit, Renderer2} from '@angular/core';
import {SecurityService} from "../../../security/security.service";
import {RightSearchByPersonalIdComponent} from "../right-search/personal-id/right-search-by-personal-id.component";
import {FormsModule} from "@angular/forms";
import {LoadingComponent} from "../../../shared/commons/loader/loading.component";
import {SharedCommonModule} from "../../../shared/commons/shared-common.module";

@Component({
  selector: 'app-internal-right-search',
  standalone: true,
  imports: [
    RightSearchByPersonalIdComponent,
    FormsModule,
    LoadingComponent,
    SharedCommonModule
  ],
  templateUrl: './internal-right-search.component.html',
  styleUrl: './internal-right-search.component.scss'
})
export class InternalRightSearchComponent implements OnInit {
  principalName?: string;
  renderer = inject(Renderer2);
  authenService = inject(SecurityService);

  ngOnInit(): void {
    this.authenService.user$()
      .subscribe((value: any) => {
        this.principalName = value?.name;
      });
  }
}
